"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDropzone = require("react-dropzone");

var _emotion = require("emotion");

var _uploadLarge = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/upload-large"));

var _uploadSmall = _interopRequireDefault(require("@amzn/meridian-tokens/base/icon/upload-small"));

var _fileInput = _interopRequireDefault(require("@amzn/meridian-tokens/component/file-input"));

var _button = _interopRequireDefault(require("../button"));

var _column = _interopRequireDefault(require("../column"));

var _icon = _interopRequireDefault(require("../icon"));

var _row = _interopRequireDefault(require("../row"));

var _text = _interopRequireDefault(require("../text"));

var _theme = require("../theme");

var _token = require("./../_utils/token");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var fileDetailsStyles = function fileDetailsStyles(t) {
  return (0, _emotion.css)({
    "& > *": {
      paddingLeft: t("fileSpacingInset"),
      paddingRight: t("fileSpacingInset")
    },
    "& > *:not(:last-child)": {
      paddingBottom: t("fileSpacingInset"),
      borderBottomWidth: t("fileBorderWidth"),
      borderBottomColor: t("fileBorderColor"),
      borderBottomStyle: "solid"
    }
  });
};

var dropZoneStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var showDropZone = _ref.showDropZone,
      isDragActive = _ref.isDragActive;
  return (0, _emotion.css)({
    transition: "opacity ".concat(t("dragOverlayContainerMotionDuration"), " ").concat(t("dragOverlayContainerMotionFunction")),
    // HACK: Disable pointer events on all the children of the container
    // (the upload button and drop zone label) when dragging because
    // dragging over those will cancel the drag operation. This behavior
    // seems to be an issue with react-dropzone.
    "& > *": {
      pointerEvents: isDragActive ? "none" : undefined
    }
  }, showDropZone ? {
    borderRadius: t("borderRadius"),
    borderWidth: t("borderWidth"),
    borderColor: t("borderColor"),
    borderStyle: "dashed"
  } : {});
}, ["showDropZone", "isDragActive"]);

var dropZoneOverlayStyles = function dropZoneOverlayStyles(t, _ref2) {
  var isDragActive = _ref2.isDragActive;
  return (0, _emotion.css)({
    borderRadius: t("borderRadius"),
    position: "absolute",
    width: "100%",
    height: "100%",
    top: 0,
    backgroundColor: t("dragOverlayContainerBackgroundColor"),
    opacity: isDragActive ? 1 : 0,
    transition: "opacity ".concat(t("dragOverlayContainerMotionDuration"), " ").concat(t("dragOverlayContainerMotionFunction")),
    pointerEvents: "none"
  });
};

var regionStyles = (0, _emotion.css)({
  position: "relative"
});
/* eslint-disable react/prop-types */

var RowOrColumn = function RowOrColumn(_ref3) {
  var direction = _ref3.direction,
      children = _ref3.children;
  return direction === "column" ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    alignmentHorizontal: "center"
  }, children) : /*#__PURE__*/_react["default"].createElement(_row["default"], null, children);
};
/* eslint-enable react/prop-types */

/**
 * Render a component to handle the front-end interactions
 * and rendering for uploading files. It's important to note
 * that FileInput does **not** provide the services for
 * actually uploading files to a back-end.
 */


var FileInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var t = (0, _theme.useTheme)(_fileInput["default"], "fileInput");
  var type = props.type,
      fileDetails = props.children,
      onFileAttached = props.onFileAttached,
      accept = props.accept;
  var dropZoneLabel = props.dropZoneLabel || props.supplementalLabel || "or drag file".concat(type === "multiple" ? "s" : "", " here");
  var dropZoneActiveLabel = props.dropZoneActiveLabel || props.activeLabel || "Drop file".concat(type === "multiple" ? "s" : "", " to upload");
  var onDrop = (0, _react.useCallback)(function (acceptedFiles) {
    onFileAttached(acceptedFiles);
  }, [onFileAttached]); // TODO: Change the default to this to plain ole false in the next major
  // version (doesn't make sense to tie drop zone to single/multiple)

  var showDropZone = props.showDropZone === undefined ? type === "multiple" : props.showDropZone;

  var _useDropzone = (0, _reactDropzone.useDropzone)({
    multiple: type === "multiple",
    noClick: !showDropZone,
    noDrag: !showDropZone,
    // We disable keyboard here because we handle focus on our own.
    noKeyboard: true,
    accept: accept,
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      open = _useDropzone.open; // Only show the file details when at least one exists to prevent the parent
  // Row from adding unnecessary spacing


  var showFileDetails = (0, _react.useMemo)(function () {
    return _react["default"].Children.toArray(fileDetails).some(Boolean);
  }, [fileDetails]);
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement(_row["default"], {
    alignmentVertical: "top"
  }, /*#__PURE__*/_react["default"].createElement("div", getRootProps({
    role: "region",
    className: regionStyles,
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: showDropZone ? "large" : "none",
    className: dropZoneStyles(t, {
      showDropZone: showDropZone,
      isDragActive: isDragActive
    })
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, passThroughProps, getInputProps())), /*#__PURE__*/_react["default"].createElement(RowOrColumn, {
    direction: props.dropZoneDirection
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    onClick: // If we've got a drop zone that'll handle all the click events
    showDropZone ? undefined : open,
    label: "".concat(props.uploadButtonLabel).concat(showDropZone ? " " + dropZoneLabel : ""),
    type: props.uploadButtonType,
    size: props.uploadButtonSize,
    disabled: props.uploadButtonDisabled,
    ref: props.buttonRef
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: props.uploadButtonSize === "small" ? _uploadSmall["default"] : _uploadLarge["default"]
  }), props.uploadButtonLabel), showDropZone ? /*#__PURE__*/_react["default"].createElement(_text["default"], null, dropZoneLabel) : null)), showDropZone ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: dropZoneOverlayStyles(t, {
      isDragActive: isDragActive
    }),
    alignmentHorizontal: "center",
    alignmentVertical: "center"
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    tokens: _uploadLarge["default"]
  }), isDragActive ? /*#__PURE__*/_react["default"].createElement(_text["default"], {
    color: "inverted",
    type: "h100",
    tag: "div"
  }, dropZoneActiveLabel) : null) : null), showFileDetails ? /*#__PURE__*/_react["default"].createElement(_column["default"], {
    className: fileDetailsStyles(t),
    minWidth: 0
  }, fileDetails) : null);
});

FileInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Callback function that fires after files have been uploaded.
   * Returns an array of files that contains file name and local path.
   */
  onFileAttached: _propTypes["default"].func.isRequired,

  /**
   * Defines what file types the file input should accept.`accept="image/*,.pdf"`,
   * for example, will force users to select image or .pdf files.
   *
   * See the [MDN docs](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept)
   * for more details and examples.
   *
   * @since  5.x
   */
  accept: _propTypes["default"].string,

  /**
   * The label that displays on the overlay that shows when files are dragged
   * onto the FileInput. Only applicable when `showDropZone` is on.
   *
   * NOTE: This is deprecated and will be removed in the next major version.
   * Please use dropZoneActiveLabel instead.
   *
   * @deprecated 5.x
   */
  activeLabel: _propTypes["default"].string,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Ref that will be passed to the file input button.
   *
   * @since 5.20.0
   */
  buttonRef: _propTypes["default"].object,

  /**
   * Expects FileDetails components. Will build a list of
   * FileDetails component.
   */
  children: _propTypes["default"].node,

  /**
   * All props prefaced with `data-` are accepted. These props will be passed
   * through to the underlying `input[type=file]` element. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * The label that displays on the overlay that shows when files are dragged
   * onto the FileInput. Only applicable when `showDropZone` is on.
   *
   * @since 5.x
   */
  dropZoneActiveLabel: _propTypes["default"].string,

  /**
   * Set the drop zone (upload button + drop zone label) direction. By default the
   * drop zone is arranged in a row with the upload button before the label.
   *
   * @since 5.10.0
   */
  dropZoneDirection: _propTypes["default"].oneOf(["row", "column"]),

  /**
   * The label displayed in the drop zone when `showDropZone` is on.
   *
   * @since 5.x
   */
  dropZoneLabel: _propTypes["default"].string,

  /**
   * Determines whether a "drop zone" is shown around the upload button to make
   * it easy to upload files by dragging and dropping them.
   *
   * NOTE: This defaults to `true` when `type="multiple"` and `false` when
   * `type="single"`. In the future this will default to `false` for both types,
   * so we recommend always setting this prop to `true` if you want this
   * feature enabled.
   *
   * @since 5.x
   */
  showDropZone: _propTypes["default"].bool,

  /**
   * The label displayed in the drop zone when `showDropZone` is on.
   *
   * NOTE: This is deprecated and will be removed in the next major version.
   * Please use dropZoneLabel instead.
   *
   * @deprecated 5.x
   */
  supplementalLabel: _propTypes["default"].string,

  /**
   * Determines whether or not the FileInput will accept multiple files.
   */
  type: _propTypes["default"].oneOf(["single", "multiple"]),

  /**
   * This disables interaction with the upload button and applies special visual
   * styles to indicate that it's not interactive.
   *
   * @since 5.x
   */
  uploadButtonDisabled: _propTypes["default"].bool,

  /**
   * The label for the upload button.
   */
  uploadButtonLabel: _propTypes["default"].string,

  /**
   * The size of the upload button. See the [Button](https://meridian.a2z.com/components/button?platform=react-web)
   * component documentation for details.
   *
   * @since 5.x
   */
  uploadButtonSize: _propTypes["default"].oneOf(["small", "medium", "large", "xlarge"]),

  /**
   * The type of the upload button. See the [Button](https://meridian.a2z.com/components/button?platform=react-web)
   * component documentation for details.
   *
   * @since 5.x
   */
  uploadButtonType: _propTypes["default"].oneOf(["primary", "secondary", "tertiary", "link"])
} : {};
FileInput.defaultProps = {
  type: "single",
  uploadButtonLabel: "Upload file",
  uploadButtonDisabled: false,
  dropZoneDirection: "row"
};
FileInput.displayName = "FileInput";
var _default = FileInput;
exports["default"] = _default;